import {
  FORMAT_DEFAULT,
  FORMAT_DEFAULT_DATE,
  FORMAT_DEFAULT_MONTH,
  stringToDayjs,
} from '../../utils';
import dayjs from '../../utils/dayjs';
import { customMap, customMapFields } from './mapError';

export const textFieldMap = customMap(({ input: { onChange } }) => ({
  onChange: (v) => onChange(v.nativeEvent.target.value),
}));

export const autoCompleteFieldMap = customMap(({ input: { onChange } }) => ({
  onChange,
}));

export const datePickerMap = (hasTime) =>
  customMap(({ input: { value, onChange } }) => {
    const format = hasTime ? FORMAT_DEFAULT : FORMAT_DEFAULT_DATE;
    const parsedValue = stringToDayjs(value, format);

    return {
      onChange: (date, dateString) => {
        onChange(date ? dateString : null);
      },
      format,
      value: parsedValue,
      defaultPickerValue: parsedValue || dayjs(),
    };
  });

export const checkboxMap = customMap(({ input: { value } }) => ({
  checked: value || false,
}));

export const monthYearMap = customMapFields((fields) => {
  const { names, ...props } = fields;
  let value;

  const { input: inputField1 } = fields[names[0]];

  const { input: inputField2 } = fields[names[1]];

  if (inputField1.value && inputField2.value) {
    value = dayjs()
      .year(inputField2.value)
      .month(inputField1.value - 1);
  }

  const onChange = (date) => {
    if (date && dayjs.isDayjs(date)) {
      inputField1.onChange(date.month() + 1);
      inputField2.onChange(date.year());
    } else {
      inputField1.onChange(null);
      inputField2.onChange(null);
    }
  };

  return {
    onChange,
    onBlur: inputField1.onBlur,
    onFocus: inputField1.onFocus,
    value,
    ...props,
  };
});

export const dateRangeNoTimeMap = customMapFields((fields) => {
  const { names, dateFormat = FORMAT_DEFAULT_DATE, ...props } = fields;

  const { input: inputField1 } = fields[names[0]];
  const { input: inputField2 } = fields[names[1]];

  const value = [
    stringToDayjs(inputField1.value, dateFormat),
    stringToDayjs(inputField2.value, dateFormat),
  ];

  const onChange = (dates, dateStrings) => {
    if (!dates || !dates.length) {
      // user cleared the picker
      inputField1.onChange(null);
      inputField2.onChange(null);
    } else {
      inputField1.onChange(dateStrings[0]);
      inputField2.onChange(dateStrings[1]);
    }
  };

  return {
    onChange,
    onBlur: inputField1.onBlur,
    onFocus: inputField1.onFocus,
    value,
    format: dateFormat,
    ...props,
  };
});

export const dateRangeMap = customMapFields((fields) => {
  const { names, dateFormat = FORMAT_DEFAULT, ...props } = fields;

  const { input: inputField1 } = fields[names[0]];

  const { input: inputField2 } = fields[names[1]];

  const value = [
    stringToDayjs(inputField1.value, dateFormat),
    stringToDayjs(inputField2.value, dateFormat),
  ];

  const onChange = (dates, dateStrings) => {
    if (!dates || !dates.length) {
      // user cleared the picker
      inputField1.onChange(null);
      inputField2.onChange(null);
    } else {
      inputField1.onChange(dateStrings[0] || null);
      const secondDate = dates[1]?.endOf('day');
      inputField2.onChange(secondDate ? secondDate.format(dateFormat) : null);
    }
  };

  return {
    onChange,
    onBlur: inputField1.onBlur,
    onFocus: inputField1.onFocus,
    value,
    format: dateFormat,
    ...props,
  };
});

export const monthRangeMap = customMapFields((fields) => {
  const { names, dateFormat = FORMAT_DEFAULT_MONTH, ...props } = fields;

  const { input: inputField1 } = fields[names[0]];

  const { input: inputField2 } = fields[names[1]];

  const value = [
    stringToDayjs(inputField1.value, dateFormat),
    stringToDayjs(inputField2.value, dateFormat),
  ];

  const onChange = (dates, dateStrings) => {
    if (!dates || !dates.length) {
      // user cleared the picker
      inputField1.onChange(null);
      inputField2.onChange(null);
    } else {
      inputField1.onChange(dateStrings[0] || null);
      inputField2.onChange(dateStrings[1] || null);
    }
  };

  const onPanelChange = (dates, mode) => {
    if (!dates || !dates.length) {
      // user cleared the picker
      inputField1.onChange(null);
      inputField2.onChange(null);
    } else {
      inputField1.onChange(dates[0] ? dates[0].format(dateFormat) : null);
      inputField2.onChange(dates[1] ? dates[1].format(dateFormat) : null);
    }
  };

  return {
    onChange,
    onPanelChange,
    onBlur: inputField1.onBlur,
    onFocus: inputField1.onFocus,
    value,
    format: dateFormat,
    picker: 'month',
    ...props,
  };
});
